export const UPDATE_ORG_START = "UPDATE_ORG_START"
export const UPDATE_ORG_SUCCESS = "UPDATE_ORG_SUCCESS"
export const UPDATE_ORG_ERROR = "UPDATE_ORG_ERROR"